import React from 'react';

export default function PrivacyPolicy() {
    var content = 'The responsible party for data processing on this website is: ' + 
                    '\nLukasz Molinek ' + 
                    '\nhilbert.mol /at/ vp.pl ' + 

                    '\n\n1. Privacy Policy for www.qamatz-mol.de ' + 
                    'This privacy policy informs users about the nature, scope, and purpose ' + 
                    'of the collection and use of personal data on the website www.qamatz-mol.de. ' + 

                    '\n\n2. Collection and Processing of Data ' + 
                    'Using our website is generally possible without providing personal data. ' + 
                    'Personal data is only collected when creating a user account (which is required to post blog comments). ' + 
                    'We use this data exclusively to process your request. Data transmission is encrypted. ' + 

                    '\n\n3. User Account ' + 
                    'If you create a user account using the registration function on www.qamatz-mol.de, ' + 
                    'the information you provide (e.g., username, email address, password) will be used to ' + 
                    'save your profile. Your data will not be shared with third parties and can be deleted at any time upon ' + 
                    'request or via the delete function. ' + 

                    '\n\n4. Blog Messages ' + 
                    'If you respond to blog posts on www.qamatz-mol.de, the information you provide (message content) ' + 
                    'along with your username/date will be used to process your message. This data will not be shared with ' + 
                    'third parties and can be deleted at any time upon request. ' + 

                    '\n\n5. Revocation of your consent to data processing ' + 
                    'You have the right to information about the personal data stored, to rectification, erasure, ' + 
                    'or restriction of processing, as well as to object to processing. To do so, contact us using ' + 
                    'the email address provided. ' + 

                    '\n\n6. Updates to this Privacy Policy ' + 
                    'This Privacy Policy may be updated to comply with current legal requirements or to reflect changes ' + 
                    'to our services. Please check the Privacy Policy at www.qamatz-mol.de regularly for updates.'; 
    return (
        <div class='privacy-policy'>
            <h1 class='mt-5'>Privacy Policy</h1>
            <div class='privacy-policy-content'>
                <div class='privacy-policy-content-text' style={{ whiteSpace: 'pre-wrap' }}>
                    { content }
                </div>
            </div>
        </div>
    );
}